<template>
    <section class="companyCard">
        <section class="companyHeader">
            <img :src="'/companies/'+ experience.urlPath + '/' + experience.logo">
            <div class="headLine">
                <h1>{{experience.name}}</h1>
                <h4>{{experience.role}}</h4>
                <p id="experienceDates">
                    {{experience.location}};
                    &nbsp;
                    {{$d(new Date(experience.joinedAt), 'condensed')}} - {{experience.current ? "Current" : $d(new Date(experience.leftAt.replace(/-/g, "/")), 'condensed')}}
                </p>
            </div>
        </section>
        <hr>
        <div id="projectsContainer" v-for="(project, index) in experience.projects" :key="project.name" >
            <ProjectCard :project="project" @gallery="openGallery" />
            <div id="separator" :v-if="shouldShowSeparator(index)">
                <hr>
            </div>
        </div>
        <div id="readMoreDiv">
            <router-link tag="button" :to="'work/' + experience.urlPath"> Learn more </router-link>
        </div>
    </section>
</template>

<script>
import ProjectCard from './ProjectCard.vue'

export default {
    data() {
        return {
            projects: 0
        }
    },
    props: [
        'experience'
    ],
    components: {
        ProjectCard
    },
    methods: {
        shouldShowSeparator(index) {
            return (index + 1) < this.projects
        },
        openGallery(images) {
            this.$emit('gallery', images)
        }
    }
}
</script>


<style scoped>
    .companyHeader {
        display: flex;
        align-items: center;
        justify-content: left;
        flex-wrap: wrap;
    }
    .companyHeader img {
        display: inline-block;
        height: 2rem;
        margin-right: 1rem;
    }
    .companyHeader .headLine {
        display: inline-block;
    }
    .headLine {
        margin-bottom: 0px;
    }
    .headLine h1 {
        display: block;
        margin-bottom: -6px;
    }
    .headLine h4 {
        color: #969696;
        margin-bottom: 0;
    }
    #readMoreDiv {
        position: relative;
    }
    #readMoreDiv button {
        width: 100%
    }
    #experienceDates {
        font-size: 0.7em;
        margin-top: 2px;
        margin-bottom: 0px;
    }
    hr {
        margin-top: 16px;
        margin-bottom: 32px;
    }
</style>

